module.exports = __webpack_public_path__ + "static/media/magic-city-bean.cf07451c.jpg";